import { UPDATE_CURRENT_NEIGHBORHOOD } from "constants-lib/actionTypes"

export const updateCurrentNeighborhood = (data) => ({
  type: UPDATE_CURRENT_NEIGHBORHOOD,
  payload: data,
})
